import React from "react";
import { Modal, Pressable, StyleSheet } from "react-native";

export default function ReportModalSheet({ visible, onClose, children, contentStyle }) {
  return (
    <Modal visible={visible} transparent animationType="slide" onRequestClose={onClose}>
      <Pressable style={styles.backdrop} onPress={onClose}>
        <Pressable style={[styles.sheet, contentStyle]} onPress={() => {}}>
          {children}
        </Pressable>
      </Pressable>
    </Modal>
  );
}

const styles = StyleSheet.create({
  backdrop: { flex: 1, justifyContent: "flex-end", backgroundColor: "rgba(0,0,0,0.42)" },
  sheet: { maxHeight: "76%", paddingHorizontal: 16, paddingTop: 20, paddingBottom: 10, borderTopLeftRadius: 18, borderTopRightRadius: 18, backgroundColor: "#FFFFFF" },
});